<template>
  <div>
    <div class="attractExample">
      <div class="intro">
        <div class="left">
          <img class="line" src="../assets/index/line.png" alt="" />
          <div class="title">加盟案例</div>
        </div>
        <div class="right">
          <div class="gc">
            {{ desc }}
          </div>
        </div>
      </div>
      <div class="bottom" v-for="(item, index) in listData" :key="index">
        <div class="left">{{ item.name }}</div>
        <div class="right">
          <img :src="item.image" alt="" />
        </div>
      </div>
      <div class="page">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          prev-text="上一页"
          next-text="下一页"
          background
          :current-page.sync="pagenum"
          layout="prev, pager, next"
          :page-size="pagesize"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { attract, attractText } from "../api/request";
export default {
  name: "AttractExample",
  data() {
    return {
      desc: "",
      // 总条目数
      total: 0,
      // 当前页数
      pagenum: 1,
      // 显示一页多少条数据
      pagesize: 3,
      picList: [
        // require("../assets/attract/1.png"),
        // require("../assets/attract/2.png"),
        // require("../assets/attract/3.png"),
        // require("../assets/attract/4.png"),
        // require("../assets/attract/5.png"),
        // require("../assets/attract/6.png"),
        // require("../assets/attract/7.png"),
        // require("../assets/attract/8.png"),
        // require("../assets/attract/9.png"),
        // require("../assets/attract/10.png"),
        // require("../assets/attract/11.png"),
        // require("../assets/attract/12.png"),
        // require("../assets/attract/13.png"),
        // require("../assets/attract/14.png"),
        // require("../assets/attract/15.png"),
      ],
      listData: [],
    };
  },
  mounted() {
    attractText().then((res) => {
      if (res.data.code == 1) {
        this.desc = res.data.data;
      }
    });

    this.init();
  },
  methods: {
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      // 第几页
      // console.log(newPage);
      //把最新的页码（newPage）赋值给 动态的 pagenum
      this.pagenum = newPage;
      this.init();

      //获取到最新显示的页码值  重新发送axios请求 这里是封装好的请求方法
    },
    //监听 pagesize 改变的事件
    handleSizeChange(newsize) {
      //这里conso 选中第几页 最新的值
      // console.log(newsize);
      //最新的条数（newsize）赋值给 动态的 pagesie
      this.pagesize = newsize;
      this.pagenum = 1;
      //获取到最新一页显示的数据  重新发送axios请求 这里是封装好的请求方法
      this.init();
    },
    init() {
      attract({ limit: this.pagesize, page: this.pagenum }).then((res) => {
        if (res.data.code == 1) {
          // console.log(res.data.data);
          // var arr = res.data.data.data;
          // 总条数
          this.total = res.data.data.count;
          this.listData = res.data.data.data;
          // this.picList = arr.map((item) => {
          //   return item.image;
          // });
          // this.pagenum = newPage;
          // var a = this.picList.map((item, index) => {
          //   if ((this.pagenum - 1) * 3 <= index && index < this.pagenum * 3) {
          //     return this.listData.push(item);
          //   }
          // });
        }
      });
    },
  },
};
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #004c31 !important;
}
</style>
<style scoped lang="less">
.attractExample {
  padding-top: 60px;
  width: 1280px;
  margin: 0 auto;
  font-family: 微软雅黑, MicrosoftYaHei;
  .intro {
    width: 1280px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .left {
      text-align: left;
    }
    .line {
      width: 90px;
      height: 8px;
    }
    .title {
      font-size: 42px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 38px;
    }
    .subTitle {
      margin-top: 24px;
      font-size: 24px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: 400;
      color: #004c31;
    }
    .right {
      text-align: justify;
      width: 960px;
      .gc {
        margin-top: 70px;
        font-size: 20px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #004c31;
        line-height: 36px;
      }
    }
  }
  .bottom {
    margin-top: 100px;
    width: 1280px;
    height: 450px;
    background: #f5f5f5;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .left {
      height: 119px;
      width: 404px;
      margin-left: 54px;
      font-size: 24px;
      font-weight: bold;
      color: #004c31;
      line-height: 119px;
      text-align: left;
      border-bottom: 1px dotted #d7d7d7;
    }
    .right {
      width: 752px;
      height: 452px;
      img {
        width: 752px;
        height: 452px;
      }
    }
  }
  .page {
    text-align: left;
    padding: 100px 0;
  }
}
@media screen and (max-width: 450px) {
  .attractExample {
    padding-top: 60px;
    width: 1280px;
    margin: 0 auto;
    font-family: 微软雅黑, MicrosoftYaHei;
    .intro {
      width: 1280px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      .left {
        text-align: left;
      }
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 38 * 2px;
      }
      .subTitle {
        margin-top: 24 * 2px;
        font-size: 24 * 2px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #004c31;
      }
      .right {
        text-align: justify;
        width: auto;
        .gc {
          margin-top: 70 * 2px;
          font-size: 20 * 2px;
          font-family: 微软雅黑, MicrosoftYaHei;
          font-weight: 400;
          color: #004c31;
          line-height: unset;
        }
      }
    }
    .bottom {
      margin-top: 100 * 2px;
      width: 1280px;
      height: 450px;
      background: #f5f5f5;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .left {
        height: 119px;
        width: 404px;
        margin-left: 54px;
        font-size: 24 * 2px;
        font-weight: bold;
        color: #004c31;
        line-height: 119px;
        text-align: left;
        border-bottom: 1px dotted #d7d7d7;
      }
      .right {
        width: 752px;
        height: 452px;
        img {
          width: 752px;
          height: 452px;
        }
      }
    }
    .page {
      height: 100px;
      text-align: left;
      padding: 100px 0;
    }
  }
  /deep/.el-pager {
    height: 100px;
    .number {
      font-size: 64px;
    }
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    font-size: 64px !important;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #004c31 !important;
    height: 5.458vw;
    line-height: 5.458vw;
  }
  /deep/.el-pagination .number {
    font-size: 64px !important;
  }
  /deep/.el-pagination.is-background .btn-prev {
    height: 5.458vw;
    line-height: 5.458vw;
    span {
      height: 5.458vw;
      line-height: 5.458vw;
      display: inline-block;
      font-size: 42px;
      padding: 0 20px;
    }
  }
  /deep/.el-pagination {
    display: flex;
    align-items: center;
    height: 5.458vw;
    line-height: 5.458vw;
  }
  /deep/.el-pager {
    height: 5.458vw;
    line-height: 5.458vw;
    display: flex;
    align-items: center;
  }
  /deep/.el-pagination.is-background .btn-next {
    height: 5.458vw;
    line-height: 5.458vw;
    padding: 0 20px;
    span {
      height: 5.458vw;
      line-height: 5.458vw;
      display: inline-block;
      font-size: 42px;
    }
  }
}
</style>
